import React from 'react';
import {
    formatIndianAmount,
    formatReceiptDate,
    getBankLabel,
    numberToIndianWords,
} from './MoneyReceiptReport';
import './MoneyReceiptTemplate.css';

const formatInWords = (amount) => {
    const words = numberToIndianWords(amount);
    if (!words) return '';
    return words.charAt(0).toUpperCase() + words.slice(1);
};

const ReceiptRow = ({ label, value, className = '' }) => (
    <div className={`row ${className}`.trim()}>
        <div className="left">{label}</div>
        <div className="value">{value}</div>
    </div>
);

const MoneyReceiptTemplate = ({ data }) => {
    if (!data) return null;

    const confirmationId = data.MRNo || '';
    const customerName = (data.CustomerName || '').replace(/\s+/g, ' ').trim();
    const mobile = data.Mobile || '';
    const receiptDate = formatReceiptDate(data.MRDate);
    const destination = data.Destination || '';
    const amount = formatIndianAmount(data.MRAmount);
    const inWords = formatInWords(data.MRAmount);
    const paymentMethod = data.ModeOfPayment || '';
    const receivedBank = getBankLabel(data.ReceivedBank);

    return (
        <div id="money-receipt-print-root" className="receipt">
            <div className="header-title">MONEY RECEIPT</div>

            <div className="top-section">
                <div className="company">
                    <strong>Explore TouristHub Holidays LLP</strong>
                    <br />
                    <b>Corp Office:</b> 63 Ananda Palit Road, Kolkata-700150
                    <br />
                    <b>Registered Office:</b> Asutosh Bhawan, M N Roy Road,
                    <br />
                    Barendrapara, Kol-700149
                    <br />
                    <b>GSTIN:</b> 19AALFE8568J1ZM
                    <br />
                    <b>Ph:</b> +91 98300 17303 / +91 99037 38567
                    <br />
                    <b>E-Mail:</b> touristhubinfo@gmail.com
                    <br />
                    www.touristhubindia.com
                </div>

                <img
                    src={`${process.env.PUBLIC_URL}/eth_logo.png`}
                    className="logo"
                    alt="Explore TouristHub Holidays"
                />
            </div>

            <div className="desc-header">Description</div>

            <div className="two-column">
                <div>
                    <ReceiptRow label="Confirmation ID :" value={confirmationId} />
                    <ReceiptRow label="Name :" value={customerName} className="row-name" />
                    <ReceiptRow label="Mobile :" value={mobile} />
                </div>

                <div>
                    <ReceiptRow label="Date :" value={receiptDate} />
                </div>
            </div>

            <div className="line" />

            <ReceiptRow label="Destination:" value={destination} />
            <ReceiptRow label="Amount:" value={amount} />
            <ReceiptRow label="In Words:" value={inWords} />
            <ReceiptRow label="Payment Method:" value={paymentMethod} />
            <ReceiptRow label="Received Bank:" value={receivedBank} />

            <div className="thank">Thank You!</div>
        </div>
    );
};

export default MoneyReceiptTemplate;
